/**
 * 菜单键值对应表
 */
export const menus = {
    // 路由配置参数, 开发以及部署时的URL
    publicPath: '/npmanager',
    // 路由模式，可选值为 history 或 hash
    routerMode: 'history',
    // routerMode: 'hash',
    // 不经过token校验的路由
    routesWhiteList: ['/login', '/register', '/404', '/401', '/999', '/tool'],
    // 缓存路由的最大数量
    keepAliveMaxNum: 99,
    // 路由缓存数据，字符串为组件中的 `name` 值，想要缓存嵌套路由，得先在当前组件中定义 `name` 值
    keepAliveList: ['/home', '/404', '/401', '/999', '/tool'],
    // 页面主容器
    rootComponent: 'layouts/default/index',
    // 页面父级容器
    nodeComponent: 'layouts/lib/parent',
    // 后端控制路由，isRequestRoutes 为 true，则开启后端控制路由
    // isRequestRoutes: false, // 使用前端路由列表的属性name不能缺失，会导致权限列表为空
    isRequestRoutes: true, // 开启后端接口路由列表
    // [menuCode,menuCode]
    affixs: ['home'],
    hides: ['ce-demo-profile', 'message-preview', 'audit-node'],
};

/* FITRUE_isMock */
// menus.isRequestRoutes = false;
/* FITRUE_isMock */
